<template>
  <div>
    <v-container fluid pa-0>
      <div class="content pa-lg-16 pa-8">
        <div class="display-1 mb-3 font-weight-bold ml-4">
          Fitur
        </div>
        <p class="ml-4">Kami juga menyediakan beberapa fitur yang akan sedia siap membantu!</p>
        <v-row wrap align="center">
          <v-col md="6" lg="3">
            <v-card class="mx-auto mb-8" max-width="300" height="325" elevation="2">
              <div class="pa-3">
                <v-img
                  :src="require('@/assets/fiturDonasi.png')"
                  max-height="150px"
                  contain
                  transition="scale-transition"
                ></v-img>

                <v-card-title class="justify-center"> Donasi Online </v-card-title>

                <v-card-subtitle class="text-center">
                  Kami menyediakan donasi online dengan menggunakan kode QRIS yang
                  bisa digunakan hampir semua media pembayaran
                </v-card-subtitle>
              </div>
            </v-card>
          </v-col>
          <v-col md="6" lg="3">
            <v-card class="mx-auto mb-8" max-width="300" height="325" elevation="2">
              <div class="pa-3">
                <v-img
                  :src="require('@/assets/fiturManajemen.png')"
                  max-height="150px"
                  contain
                  transition="scale-transition"
                ></v-img>

                <v-card-title class="justify-center"> Manajemen Donasi </v-card-title>

                <v-card-subtitle class="text-center">
                  Kami menyediakan manajemen donasi untuk mengelola persebaran dan
                  track donasi
                </v-card-subtitle>
              </div>
            </v-card>
          </v-col>
          <v-col md="6" lg="3">
            <v-card class="mx-auto mb-8" max-width="300" height="325" elevation="2">
              <div class="pa-3">
                <v-img
                  :src="require('@/assets/fiturPelatihan.png')"
                  max-height="150px"
                  contain
                  transition="scale-transition"
                ></v-img>

                <v-card-title class="justify-center"> Pelatihan Desain </v-card-title>

                <v-card-subtitle class="text-center">
                  Kami menyediakan pelatihan desain untuk mendukung Masjid memiliki
                  publikasi yang menarik
                </v-card-subtitle>
              </div>
            </v-card>
          </v-col>
          <v-col md="6" lg="3">
            <v-card class="mx-auto mb-8" max-width="300" height="325" elevation="2">
              <div class="pa-3">
                <v-img
                  :src="require('@/assets/fiturJasa.png')"
                  max-height="150px"
                  contain
                  transition="scale-transition"
                ></v-img>

                <v-card-title class="justify-center"> Jasa Desain </v-card-title>

                <v-card-subtitle class="text-center">
                  Kami menyediakan jasa desain untuk mendukung Masjid memiliki
                  publikasi yang menarik
                </v-card-subtitle>
              </div>
            </v-card>
          </v-col>
        </v-row>
    </div>
    </v-container>
  </div>
</template>

<style scoped>
.justify-center {
  color: #1A8D2B
}
</style>
<script>
export default {};
</script>
